import { useSnapshot } from 'valtio'
import { AppStore } from '../store/store'
import ApartmentsM from '../components/ApartmentsM'
import ApartmentsP from '../components/ApartmentsP'

const Floor = () => {
  const { selectedObject } = useSnapshot(AppStore)

  switch (selectedObject) {
    case 'М':
      return <ApartmentsM />

    case 'П':
      return <ApartmentsP />

    default:
      return <div className="loader_container"><div className="loader" /></div>
  }
}

export default Floor
